import { Link } from 'react-router';
import type { DispatchPreview } from '../dispatch.api';
import { dispatchPaths } from '../dispatch.paths';

const formatter = new Intl.DateTimeFormat('en-KE', { dateStyle: 'medium', timeStyle: 'short' });
const when = (iso: string) => formatter.format(new Date(iso));

/** The crew the trip holds, its route and the period it is committed for. Changing the crew is the assign screen's job, so this only links there. */
export function DispatchCrewCard({ preview, canChange }: { preview: DispatchPreview; canChange: boolean }) {
  const { crew, trip, timeline } = preview;
  const rows: [string, string][] = [
    ['Truck', crew.truck?.label ?? 'None'],
    ['Trailer', crew.trailer?.label ?? 'None'],
    ['Driver', crew.driver?.label ?? 'None'],
    ['Route', `${trip.originZoneCode ?? '—'} → ${trip.destinationZoneCode ?? '—'}`],
    ['Committed', `${when(timeline.start)} to ${when(timeline.end)}`],
  ];
  return (
    <section aria-label="Crew and route" className="rounded-lg border border-line bg-surface p-5">
      <div className="mb-3 flex items-center justify-between gap-3">
        <h2 className="text-base font-semibold text-fg">Crew and route</h2>
        {canChange && (
          <Link className="text-sm text-primary" to={dispatchPaths.assignTrip(trip.id)}>
            Change crew or trailer
          </Link>
        )}
      </div>
      <dl className="grid grid-cols-[8rem_1fr] gap-y-2 text-sm">
        {rows.map(([term, value]) => (
          <div key={term} className="contents">
            <dt className="text-muted">{term}</dt>
            <dd className="text-fg">{value}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
